module.exports = __webpack_public_path__ + "static/img/max_pictgrid29_1020x856.754b1e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/max_pictgrid29_1020x856.jpg
// module id = HIHw
// module chunks = 0